import { PERMISSIONS } from 'components/account/AccountView/users/constants';
import { BULK_PROPERTY_UPLOAD_SELF_SERVE } from 'components/admin/utils/feature-flags';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import { useUser } from 'controllers/contexts/user';
import useAuth from 'hooks/useAuth';

export type PropertyUploadsAccess = 'loading' | 'allowed' | 'denied';

/**
 * Admins always have access. Merchant users need the shop's
 * `bulk_property_upload_self_serve` lab and `subscribers_write` in their
 * token permissions, whether or not the shop has the RBAC_ROLES lab: the API
 * always checks the token. This only shapes the UI.
 */
export default function useCanUsePropertyUploads(): PropertyUploadsAccess {
  const { user } = useUser();
  const { hasLabsFlag, hasInitialized } = usePSLabs();
  const { userHasPermission } = useAuth();

  if (user?.is_admin) return 'allowed';
  if (!hasInitialized) return 'loading';
  if (!hasLabsFlag(BULK_PROPERTY_UPLOAD_SELF_SERVE)) return 'denied';
  return userHasPermission(PERMISSIONS.subscribers_write)
    ? 'allowed'
    : 'denied';
}
